// extracted by mini-css-extract-plugin
export var ipadFrame = "TabletScreen-module--ipadFrame--vuUL6";
export var ipadFrame__mockup = "TabletScreen-module--ipadFrame__mockup--SUFkz";
export var ipadFrame__screen = "TabletScreen-module--ipadFrame__screen--A-jt5";
export var ipad__frame = "TabletScreen-module--ipad__frame--+KLVv";
export var ipad__frame__container = "TabletScreen-module--ipad__frame__container--XPAVp";
export var ipad__frame__container__background = "TabletScreen-module--ipad__frame__container__background--VD3oP";
export var ipad__frame__container__card = "TabletScreen-module--ipad__frame__container__card--h1r9H";